<i18n>
{
  "ru": {
    "sdk_iframe": "Встраиваемая страница (iframe)",
    "sdk_page": "Независимая страница"
  },
  "en": {
    "sdk_iframe": "IFrame",
    "sdk_page": "Page"
  }
}
</i18n>
<template>
  <el-dialog
    custom-class="webpay client"
    :visible.sync="visibleInner"
    top="1vh"
  >
    <span slot="title" v-if="!loading">
      <h4 v-if="model.client_id">{{ $t("edit") }}</h4>
      <h4 v-if="!model.client_id">{{ $t("add") }}</h4>
    </span>
    <div v-loading="loading">
      <el-form
        ref="clientForm"
        @submit.native.prevent="save"
        :show-message="false"
        :model="model"
        :rules="rules"
      >
        <el-form-item :label="$t('short_name')" prop="s_name">
          <el-input size="mini" v-model="model.s_name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('name')" prop="name">
          <el-input size="mini" v-model="model.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('default_template')" prop="default_template">
          <el-select size="mini" v-model="model.default_template" filterable>
            <el-option
              v-for="(label, value) in templates"
              :key="value"
              :label="label"
              :value="parseInt(value)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Тип работы веб-интерфейса" prop="websdk_type">
          <el-select size="mini" v-model="model.websdk_type" filterable>
            <el-option
              v-for="item in sdkTypes"
              :key="item.value"
              :label="$t(item.label)"
              :value="parseInt(item.value)"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          v-if="model.websdk_type == 1"
          :label="$t('return_url')"
          prop="return_url"
        >
          <el-input size="mini" v-model="model.return_url"></el-input>
        </el-form-item>

        <el-form-item :label="$t('custom_css')" prop="custom_css">
          <el-checkbox v-model="model.custom_css"></el-checkbox>
        </el-form-item>

        <el-form-item :label="$t('postback_url')" prop="postback_url">
          <el-input size="mini" v-model="model.postback_url"></el-input>
        </el-form-item>
        <el-form-item label="Тип Postback" prop="postback_type">
          <el-select size="mini" v-model="model.postback_type">
            <el-option value="formdata">formdata</el-option>
            <el-option value="json">json</el-option>
          </el-select>
        </el-form-item>

        <el-button
          class="aligner right"
          round
          type="primary"
          native-type="submit"
          >{{ $t("save") }}</el-button
        >
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import apiRes from '../../core/apiRes'

export default {
  name: 'client-modal',
  props: ['client', 'callback', 'visible', 'templates'],
  computed: {
    visibleInner: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('update:visible', false)
        }
      }
    }
  },
  data() {
    return {
      loading: true,
      sdkTypes: [{ label: 'sdk_page', value: 1 }, { label: 'sdk_iframe', value: 2 }],
      model: { name: '', s_name: '', websdk_type: 1, default_template: 1, custom_css: false, postback_url: '', return_url: '', postback_type: 'formdata' },
      rules: {
        s_name: { required: true, trigger: 'blur' },
        default_template: { required: true, trigger: 'blur' }
      }
    }
  },
  created() {
    Object.assign(this.model, this.client)
    this.model.custom_css = !!this.model.custom_css
    this.loading = false
  },
  methods: {
    save() {
      this.$refs['clientForm'].validate(valid => {
        if (valid) {
          this.loading = true
          let toSend = { action: 'save' }
          Object.assign(toSend, this.model)
          toSend.custom_css = toSend.custom_css ? 1 : 0
          apiRes
            .post(apiRes.idcheckClients, toSend)
            .then(res => {
              if (res.page_vars) {
                this.callback(res.page_vars)
                this.visibleInner = false
              }

              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    }
  }
}
</script>

<style>
.el-dialog.webpay.client {
  max-width: 532px;
}
</style>
